export default __webpack_public_path__ + "static/universal-ml-adb3e9b801a229f465990de7202c3063.jpg";